import { render, staticRenderFns } from "./ProdDetails.vue?vue&type=template&id=a623cd2e&scoped=true&"
import script from "./ProdDetails.vue?vue&type=script&lang=js&"
export * from "./ProdDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProdDetails.vue?vue&type=style&index=0&id=a623cd2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a623cd2e",
  null
  
)

export default component.exports